<template>
    <div class="news-nav">
        <div class="orange-bg"></div>
        <div class="news-wrapper">
            <div class="news-container">
                <div class="news-content">
                    <div class="news-item" v-for="appNews in allAppNews">
                        <div class="item-bg-img"
                             v-lazy:background-image="appNews.near_news_pic_url"></div>
                        <div class="mask"></div>
                        <div class="content" @click="openWeb(appNews.detail_href)">
                            <!--<h2 class="item-title">{{appNews.app_name}}</h2>-->
                            <!--<p class="item-desc">{{ appNews.big_title }}</p>-->
                        </div>
                    </div>

                    <div class="news-list">
                        <router-link to="news" class="plus">
                            <span>+</span>
                        </router-link>
                        <div class="content">
                            <router-link :to="'news/' + allNews[0].id" v-if="allNews.length>0" style="text-decoration: none;">
                                <h1 class="title">{{allNews[0].title}}</h1>
                            </router-link>
                            <ul class="list">
                                <li v-for="(news,index) in allNews" class="li" v-if="index>=1&&index<=5">
                                    <router-link :to="'news/' + news.id">
                                        <p class="title">[{{ $t('typeNews') }}] {{ news.title }}</p>
                                        <p class="date">{{ news.news_date }}</p>
                                    </router-link>

                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import md5 from 'blueimp-md5'
    import globals from '../../config/global'

    export default {
        data: function () {

            return {
                allAppNews: [],
                allNews: []

            }


        },
        methods: {
            openWeb(url) {
                window.open(url)
            }
        },
        beforeMount() {
            if (globals.methods.getStorageItem('nearNewsData')) {
                let tmp = JSON.parse(globals.methods.getStorageItem('nearNewsData'));
                this.allAppNews = tmp.resApp
                this.allNews = tmp.resNews
                return
            }
            let timeStamp = Date.parse(new Date());
            let sign = md5(timeStamp)
            let that = this
            let extraParam = '&platform=2'//1英卓，2萌果
            if(globals.isTest){//测试环境会获取未审核的内容
                extraParam += '&isTest=1'
            }
            this.$http.get(globals.enjoyUrl + 'enjoysiteapi/getnearnews?timestamp=' + timeStamp + '&sign=' + sign + extraParam).then(
                function (response) {
                    that.allAppNews = response.data.resApp
                    that.allNews = response.data.resNews
                    if (that.allNews.length == 0) {
                        globals.methods.setStorageItem('nearNewsData',response.data)
                        return
                    }
                    if (that.allNews[0].title.length > 20) {
                        that.allNews[0].title = that.allNews[0].title.substr(0, 20) + '...'
                    }
                    globals.methods.setStorageItem('nearNewsData',response.data)

                });
        }
    }
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    @import "../../assets/scss/lib.scss";

    .news-nav {
        height: 331px;
        width: 100%;
        z-index: 10;
        position: absolute;
        bottom: 0;
        .orange-bg {
            height: 210px;
            width: 100%;
            background: $orange-color;
            position: absolute;
            bottom: 0;
        }
        .news-wrapper {
            height: 331px;
            box-sizing: border-box;
            .news-container {
                width: 1080px;
                height: 331px;
                margin: 0 auto;
                position: relative;
                .news-content {
                    position: absolute;
                    z-index: 1;
                    width: 1080px;
                    height: 331px;
                    @include flex-row-center;
                    overflow: hidden;
                }
            }
        }
    }

    .news-item {
        height: 331px;
        width: 312px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        .item-bg-img {
            height: 331px;
            width: 322px;
            background-size: 322px 331px;
            background-position: top left;
            margin-left: 0;
            transition: all .3s linear;
        }
        .mask {
            position: absolute;
            left: 0;
            top: 0;
            height: 331px;
            width: 312px;
            background: rgba(0, 0, 0, 0.5);
        }
        .bottom-bg {
            opacity: 0.6;
            width: 100%;
            height: 0;
            background: #ffab27;
            position: absolute;
            bottom: 0;
            transition: all .2s linear;
        }
        .content {
            position: absolute;
            top: 0;
            left: 0;
            height: 331px;
            width: 312px;
            z-index: 10;
            color: #fff;
            text-align: center;
            .item-title {
                padding: 62px 10px 0;
                height: 86px;
                box-sizing: border-box;
                transition: all .2s linear;
            }
            p {
                box-sizing: border-box;
                font-size: 14px;
                line-height: 20px;
            }
            .item-desc {
                position: absolute;
                bottom: 125px;
                width: 100%;
                left: 0;
                top: 70%;
                padding: 0 50px;
                transition: all .2s linear;
            }
            .item-like {
                position: absolute;
                bottom: 20px;
                width: 100%;
                font-size: 14px;
                transition: all .2s linear;
                &:hover {
                    font-size: 16px;
                    transition: all .2s linear;
                    .link-heart {
                        color: red;
                    }
                }
            }
        }
    }

    .news-item:hover {
        .item-bg-img {
            margin-left: -10px;
            transition: all .3s linear;
        }
        .mask {
            display: none;
        }
        .bottom-bg {
            height: 115px;
            opacity: 1;
            transition: all .2s linear;
        }
        .content {

            /*.item-title {*/
            /*padding-top: 20px;*/
            /*padding-bottom: 70px;*/
            /*background: linear-gradient(to bottom, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.2) 75%, rgba(0, 0, 0, 0) 100%);*/
            /*height: 56px;*/
            /*margin-bottom: 30px;*/
            /*transition: all .3s linear;*/
            /*}*/
            /*.item-desc {*/
            /*top: 70%;*/
            /*transition: all .2s linear;*/
            /*}*/
        }
    }

    .news-item {
        background-repeat: no-repeat;
        background-position: top center;
    }

    .news-list {
        height: 331px;
        width: 1080px - 2*312px;
        background: #333;
        position: relative;
        .plus {
            color: #fff;
            position: absolute;
            top: 0;
            right: 0;
            width: 0;
            height: 0;
            border-top: 45px solid $orange-color;
            border-left: 45px solid transparent;
            span {
                position: absolute;
                top: -50px;
                right: 2px;
                font-size: 35px;
            }
        }
        .content {
            padding: 0 35px;
            margin-top: 45px;
            box-sizing: border-box;
            .title {
                font-size: 31px;
                color: $orange-color;
            }
            .title-empty {
                height: 44px;
            }
            .list {
                width: 100%;
                border-top: 1px solid gray;
                margin-top: 10px;
                list-style: none;
                .li {
                    width: 100%;
                    margin-top: 10px;
                    a {
                        @include flex-row-center;
                        text-decoration: none;
                        .title {
                            font-size: 14px;
                            color: #a6a6a6;
                            @include flex-grow(1);
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            &:hover {
                                color: #fff;
                            }
                        }
                        .date {
                            font-size: 14px;
                            color: #a6a6a6;
                            width: 80px;
                            @include flex-grow(0);
                            text-align: right;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// GameNews.vue?e18b4bac